// Copyright (c) 2026 Celadon Development LLC, All rights reserved.
// Author Vasily Klyuev <vasily.klyuev@celadon.ae>
export const getLoader = state => state.redeemVoucherReducer.loading;
export const getCode = state => state.redeemVoucherReducer.code;
export const getAmount = state => state.redeemVoucherReducer.amount;
export const getVoucher = state => state.redeemVoucherReducer.voucher;
export const getMessage = state => state.redeemVoucherReducer.message;
